<form 
    (ngSubmit)="$event.preventDefault(); saveSituation();"
    [formGroup]="situationForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Threat Assessment Situation
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4"> 
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full flex flex-row items-center justify-between font-semibold">
                    <p>Describe in detail the situation that prompted the Threat Assessment: *</p>
                    <div *ngIf="canEdit || canAdmin" class="relative flex items-center justify-center">
                        <button
                            data-tooltip-target="tooltip-link-a-tip"  data-tooltip-placement="bottom"
                            class="w-8 h-8 flex items-center justify-center gap-2 text-nside-orange-400 hover:text-nside-orange-300 pb-1"
                            (click)="$event.preventDefault(); showTipsTable = true; getTipsByBuildingId()"
                        >
                            <lucide-icon [img]="icons.ClipboardCopy"></lucide-icon>
                        </button>
                        <div id="tooltip-link-a-tip" role="tooltip" class="absolute z-10 invisible inline-block whitespace-nowrap px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                            Link A Tip
                            <div class="tooltip-arrow" data-popper-arrow></div>
                        </div>
                    </div>
                </div>
                <div class="w-full flex flex-col items-center">
                    <textarea 
                        formControlName="detail_of_situation"
                        rows="3"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        placeholder="Situation Description..."
                    ></textarea>
                </div>
            </div>  
            <div class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold">
                    <p>Date and Time of Incident: *</p>
                </div>
                <div class="w-full flex items-center gap-2">
                    <div class="relative">
                        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                            </svg>
                        </div>
                        <input id="datepicker-incident-date" #datepickerIncidentDate name="date_of_incident" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2">
                    </div>
                    <div class="relative">
                        <div class="absolute inset-y-0 end-0 top-0 flex items-center pe-3 pointer-events-none">
                            <svg class="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                        <input type="time" formControlName="time_of_incident" class="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2" min="09:00" max="18:00" required />
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Did the incident occur on campus? *</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div>
                        <input type="radio" id="incident_on_campus_yes" value="{{ this.yesNo.Yes }}" class="hidden peer"
                            formControlName="incident_on_campus"
                        >
                        <label for="incident_on_campus_yes"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Yes, the incident occurred on campus.
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="incident_on_campus_no" value="{{ this.yesNo.No }}" class="hidden peer"
                            formControlName="incident_on_campus"
                        >
                        <label for="incident_on_campus_no"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            No, the incident occured off campus, online or the location is unknown or not applicable.
                        </label>
                    </div>
                </div>
            </div>            
            <div class="w-full flex flex-col items-center text-start">
                <div *ngIf="situationForm.get('incident_on_campus')?.value == this.yesNo.Yes" class="w-full font-semibold">
                    <p>Please use the nSide Maps viewer to identify the location of the incident on the campus map.</p>
                    <p>Incident Location URL: *</p>
                </div>
                <div *ngIf="situationForm.get('incident_on_campus')?.value == this.yesNo.No" class="w-full font-semibold">
                    <p>Please use the following fields to record information regarding the location of the incident.</p>
                    <p>Incident Location Description: *</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <input 
                        type="text"
                        formControlName="incident_location"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                        placeholder="Incident Location..."
                    >
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.situationForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.situationForm.valid
                }"
                [disabled]="this.situationForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>

<tip-modal
    *ngIf="showTipsTable && tips && tips.length > 0"
    [tips]="tips"
    (close)="showTipsTable = false"
    (selectTip)="applyTipSummary($event.summary, $event.id)"
></tip-modal>

<div *ngIf="loading">
    <spinner></spinner>
</div>